export default __webpack_public_path__ + "no-remittance-receipt.d51e8fa110a816a9544f8683ef0c923a.svg";